import React from 'react';

import * as S from './styled';

export const Loader = () => {
  return <S.Loader className="loading" />;
};
